import React from 'react';

const PartnershipTerms = () => {
  return (
    <div className="content">
      <p>
        주식회사 아이나비시스템즈(이하 "회사"라 함)는 고객님의 개인정보를 매우
        중요시하며 고객님이 회사의 회원 서비스를 이용하기 위해 제공한 개인정보를
        안전하게 관리하고 보호할 수 있도록 최선을 다하고 있습니다.
      </p>
      <p>
        회사는 「개인정보 보호법」, 「정보통신망 이용촉진 및 정보보호 등에 관한
        법률」, 기타 개인정보 관련 법규를 준수하고 있으며, 개인정보처리방침을
        통하여 고객님이 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있고
        개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
      </p>
      <p>
        본 개인정보처리방침은 관련 법규 또는 회사 내부 방침의 변경에 따라 개정될
        수 있으며, 본 개인정보처리방침을 개정하는 경우 회사
        웹사이트(www.inavisys.com)의 공지사항(또는 개별공지)을 통하여
        공지됩니다.
      </p>
      <p>
        회사는 「개인정보 보호법」 제30조에 따라 정보주체의 개인정보를 보호하고
        이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과
        같이 개인정보처리에 관한 방침을 수립 및 공개합니다.
      </p>
      <p>&nbsp;</p>
      <table>
        <tbody>
          <tr>
            <td width="601">
              <p>[목 차]</p>
              <p>1.개인정보 수집범위 및 이용목적</p>
              <p>2.개인정보의 보유 및 이용기간</p>
              <p>3.개인정보의 파기</p>
              <p>4.정보주체와 법정대리인의 권리․의무 및 행사방법</p>
              <p>5.개인정보의 처리위탁</p>
              <p>6.개인정보의 제3자 제공</p>
              <p>7.개인정보의 안전성 확보조치</p>
              <p>8.개인정보 자동 수집 장치의 설치∙운영 및 거부에 관한 사항</p>
              <p>9.개인 아이디와 비밀번호 관리</p>
              <p>10.링크사이트</p>
              <p>11.개인정보보호책임자 및 담당부서</p>
              <p>12. 개인위치정보의 처리</p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
      <ol>
        <li>
          <strong>개인정보 수집범위 및 이용목적</strong>
        </li>
      </ol>
      <p>
        ① 회원가입 시 회사는 각종 서비스를 이용하는데 있어, 원활한 서비스 이용
        및 편리하고 유익한 맞춤정보를 제공하기 위하여 아래와 같이 개인정보를
        수집합니다.
      </p>
      <table width="664">
        <tbody>
          <tr>
            <td width="132">
              <p>서비스</p>
            </td>
            <td width="142">
              <p>수집시점</p>
            </td>
            <td width="227">
              <p>개인정보 수집항목</p>
            </td>
            <td width="163">
              <p>처리목적</p>
            </td>
          </tr>
          <tr>
            <td rowSpan="5" width="132">
              <p>아이나비AIR</p>
              <p>(내비게이션 서비스)</p>
            </td>
            <td width="142">
              <p>회원가입</p>
            </td>
            <td width="227">
              <p>
                (필수) 휴대폰 전화번호, 휴대폰 단말기 정보, 단말기 고유값,
                위치정보, 고객의 GPS 궤적데이터, 서비스 이용 로그 수집 데이터
              </p>
            </td>
            <td rowSpan="3" width="163">
              <p>
                회원가입 및 고객식별, 유/무료 기간 확인, 서비스 제공 및 품질
                개선
              </p>
            </td>
          </tr>
          <tr>
            <td width="142">
              <p>SNS ID 계정연동</p>
            </td>
            <td width="227">
              <p>① Apple : 이메일주소, 애플로그인 식별값</p>
              <p>
                ② Google : 이름, 이메일주소, 언어 환경설정, 프로필사, Google
                로그인 식별값
              </p>
              <p>
                ③ kakao : (필수) 프로필정보(닉네임/프로필사진) / (선택)
                카카오계정(이메일)
              </p>
            </td>
          </tr>
          <tr>
            <td width="142">
              <p>팅크웨어 통합멤버쉽 계정연동</p>
            </td>
            <td width="227">
              <p>(필수) 이메일</p>
            </td>
          </tr>
          <tr>
            <td width="142">
              <p>회원정보 관리 (선택)</p>
            </td>
            <td width="227">
              <p>(선택) 생년월일, 성별</p>
            </td>
            <td width="163">
              <p>사용자 통계 및 서비스 품질 개선</p>
            </td>
          </tr>
          <tr>
            <td width="142">
              <p>내 차량등록 (선택)</p>
            </td>
            <td width="227">
              <p>
                (선택) 차종, 유종, 하이패스, 국가 유공자 및 장애인 할인,
                차량번호, 성별
              </p>
            </td>
            <td width="163">
              <p>고객별 맞춤형 서비스 제공</p>
            </td>
          </tr>
          <tr>
            <td rowSpan="2" width="132">
              <p>아이나비FMS</p>
              <p>(차량관제서비스)</p>
            </td>
            <td width="142">
              <p>로그인</p>
            </td>
            <td width="227">
              <p>
                (필수) 이메일, 닉네임, 통합멤버쉽 회원코드, 사용자의 GPS
                궤적데이터, 서비스 이용로그 수집 데이터, 휴대폰전화번호, 이벤트
                발생 시 개인영상, 이미지, 블랙박스 좌표
              </p>
            </td>
            <td width="163">
              <p>
                회원가입 및 고객식별, 유/무료 기간 확인, 서비스 제공 및 품질
                개선
              </p>
            </td>
          </tr>
          <tr>
            <td width="142">
              <p>차량등록 (선택)</p>
            </td>
            <td width="227">
              <p>(선택) 차량번호</p>
            </td>
            <td width="163">
              <p>고객별 맞춤형 서비스 제공</p>
            </td>
          </tr>
          <tr>
            <td rowSpan="2" width="132">
              <p>fivepin 서비스</p>
            </td>
            <td width="142">
              <p>로그인</p>
            </td>
            <td width="227">
              <p>(필수) 이메일</p>
            </td>
            <td width="163">
              <p>서비스 제공</p>
            </td>
          </tr>
          <tr>
            <td width="142">
              <p>1:1 문의</p>
            </td>
            <td width="227">
              <p>(필수) 이메일, 문의 내용</p>
            </td>
            <td width="163">
              <p>1:1 문의</p>
            </td>
          </tr>
          <tr>
            <td width="132">
              <p>하이핀</p>
            </td>
            <td width="142">
              <p>회원가입</p>
            </td>
            <td width="227">
              <p>
                ① kakao : (필수) 닉네임, 카카오계정(전화번호), 카카오 로그인
                식별값
              </p>
              <p>(선택) 생일, 프로필사진, 성별, 출생연도</p>
              <p>② Apple : (필수) 애플 로그인 식별값</p>
              <p>③ 공통 : (필수) 휴대폰번호, 닉네임, 위치정보</p>
              <p>(선택) 생일, 프로필사진, 성별, 출생연도</p>
            </td>
            <td width="163">
              <p>
                회원가입(이용자 식별, 중복가입방지, 정보고지, 상담, 친구추천,
                맞춤기능제공) 및 서비스 제공
              </p>
            </td>
          </tr>
          <tr>
            <td rowSpan="3" width="132">
              <p>INAVI Maps</p>
              <p>(INAVI Maps Platform Service)</p>
            </td>
            <td width="142">
              <p>SNS ID 계정연동</p>
            </td>
            <td width="227">
              <p>(필수)</p>
              <p>① Naver : 이름, 이메일 주소, 전화번호</p>
              <p>② Google : 이름, 이메일 주소, 전화번호</p>
              <p>
                ③ kakao : 프로필정보(닉네임/프로필사진), 카카오계정(이메일),
                전화번호
              </p>
            </td>
            <td width="163">
              <p>회원가입 및 고객식별, 서비스 제공 및 품질 개선</p>
            </td>
          </tr>
          <tr>
            <td width="142">
              <p>개발 문의</p>
            </td>
            <td width="227">
              <p>(필수) 이름, 이메일, 문의 내용</p>
            </td>
            <td width="163">
              <p>개발 문의</p>
            </td>
          </tr>
          <tr>
            <td width="142">
              <p>1:1 문의</p>
            </td>
            <td width="227">
              <p>(필수)</p>
              <p>① 이름</p>
              <p>② 회사(기관명)</p>
              <p>③ 연락처</p>
              <p>④ 이메일</p>
              <p>&nbsp;</p>
              <p>(선택)</p>
              <p>① 부서/직책</p>
            </td>
            <td width="163">
              <p>
                도입 문의, 견적 문의, 상품 이용 문의, 제휴 문의, 기타 문의 시
              </p>
              <p>고객식별, 서비스 제공 및 회신</p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
      <p>
        ② 고객이 제공한 모든 정보는 상기 목적에 필요한 용도 이외로는 사용되지
        않으며, 수집정보의 범위나 사용목적, 용도가 변경될 시에는 「개인정보
        보호법」 제18조에 따라 반드시 고객에게 별도의 동의를 받는 등 필요한
        조치를 이행할 것입니다.
      </p>
      <p>
        ③ 회사는 고객님의 개인정보를 수집할 경우 반드시 고객님의 동의를 얻어
        수집하며, 고객님의 기본적 인권을 침해 할 우려가 있는 민감한
        개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및
        범죄기록, 건강상태 및 성생활 등)는 수집하지 않습니다. 그리고 어떤
        경우에라도 입력하신 정보를 고객님들에게 미리 밝힌 목적 이외의 다른
        목적으로는 사용하지 않으며 외부로 유출하지 않습니다.
      </p>
      <p>&nbsp;</p>
      <ol start="2">
        <li>
          <strong>개인정보의 이용 및 보유기간</strong>
        </li>
      </ol>
      <p>
        ① 회사는 법령에 따른 개인정보 이용&bull;보유기간 또는 고객님으로부터
        개인정보를 수집 시에 동의받은 개인정보 이용&bull;보유기간 내에서
        개인정보를 처리&bull;보유합니다.
      </p>
      <table>
        <tbody>
          <tr>
            <td width="301">
              <p>개인정보</p>
            </td>
            <td width="301">
              <p>파기시점</p>
            </td>
          </tr>
          <tr>
            <td width="301">
              <p>홈페이지 회원 가입 및 관리</p>
            </td>
            <td width="301">
              <p>
                서비스 또는 계약해지(탈퇴신청 또는 회원제명), 홈페이지 탈퇴
                시까지
              </p>
              <p>다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시까지</p>
              <p>
                1) 관계 법령 위반에 따른 수사․조사 등이 진행 중인 경우에는 해당
                수사․조사 종료 시까지
              </p>
              <p>
                2) 홈페이지 이용에 따른 채권․채무관계 잔존 시에는 해당
                채권․채무관계 정산 시까지
              </p>
            </td>
          </tr>
          <tr>
            <td width="301">
              <p>설문조사, 이벤트 등 일시적 목적을 위해 수집한 경우</p>
            </td>
            <td width="301">
              <p>당해 설문조사, 이벤트 등 종료시</p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        ② 단, 아래에 열거한 경우를 포함하여 관련 법령의 규정에 의하여 거래 관련
        권리 의무 관계의 확인 등을 이유로 개인정보를 보유하여야 할 필요가 있을
        경우에는 해당 기간동안 보유하며, 해당 기간 동안 고객님의 정보를 다른
        목적으로 사용하지 않습니다.
      </p>
      <p>
        1) 『전자상거래 등에서의 소비자 보호에 관한 법률』에 따른 표시․광고,
        계약내용 및 이행 등 거래에 관한 기록
      </p>
      <p>- 표시․광고에 관한 기록 : 6개월</p>
      <p>- 계약 또는 청약철회, 대금결제, 재화 등의 공급기록 : 5년</p>
      <p>- 소비자 불만 또는 분쟁처리에 관한 기록 : 3년</p>
      <p>2) 『통신비밀보호법』에 따른 통신사실확인자료 보관</p>
      <p>
        - 가입자 전기통신일시, 개시․종료시간, 상대방 가입자번호, 사용도수,
        발신기지국 위치추적자료 : 1년
      </p>
      <p>- 컴퓨터통신, 인터넷 로그기록자료, 접속지 추적자료 : 3개월</p>
      <p>&nbsp;</p>
      <ol start="3">
        <li>
          <strong>개인정보의 파기</strong>
        </li>
      </ol>
      <p>① 회사의 개인정보 파기</p>
      <p>
        1) 회사는 고객님의 개인정보를 개인정보의 보유 및 이용기간에 명시한
        보유목적이 달성되는 등 개인정보가 불필요하게 되었을 때 지체없이
        파기합니다.
      </p>
      <p>
        2) 회사는 고객님으로부터 동의받은 개인정보 보유기간이 경과하거나
        처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속
        보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로
        옮기거나 보관장소를 달리하여 보존합니다.
      </p>
      <p>② 파기절차 및 방법</p>
      <p>
        1) 파기절차: 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보
        보호책임자의 승인을 받아 개인정보 관리자는 파기하는 개인정보의 파일
        형태에 따라 복구 또는 재생이 되지 않는 안전한 방법으로 처리하도록 관리
        감독하여 개인정보를 파기합니다.
      </p>
      <p>2) 파기방법:</p>
      <table width="614">
        <tbody>
          <tr>
            <td width="125">
              <p>파기 대상 파일 형태</p>
            </td>
            <td width="489">
              <p>안전한 파기방법</p>
            </td>
          </tr>
          <tr>
            <td width="125">
              <p>
                업무용PC에 저장된 <br /> 개인정보 파일
              </p>
            </td>
            <td width="489">
              <p>
                디스크, USB메모리의 경우 '로우레벨포멧(Low level
                format)'방법으로 파기
              </p>
            </td>
          </tr>
          <tr>
            <td width="125">
              <p>전자적 파일 형태</p>
            </td>
            <td width="489">
              <p>
                서비스 중인 DB의 Delete 쿼리를 통해 해당 개인정보 전체
                삭제(delete)
                <br /> <br /> DB의 특정부분에 덮어쓰기가 곤란한 경우에는 테이블
                데이터에 논리적인 삭제(delete)도 허용되나, 신속하게 다른
                데이터로 덮어쓰기(overwriting)될 수 있도록 운영
              </p>
            </td>
          </tr>
          <tr>
            <td width="125">
              <p>출력물 형태</p>
            </td>
            <td width="489">
              <p>
                사무공간 각 층에 구비된 파쇄기 등을 이용한 파기
                <br /> 파쇄 전문업체 통하여 주기적으로 문서 파기
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
      <p>
        - 해당 개인정보의 처리가 제3자에게 위탁된 경우에는 수탁자가 더 이상 해당
        개인정보를 처리하지 못하도록 합니다
      </p>
      <p>&nbsp;</p>
      <ol start="4">
        <li>
          <strong>정보주체와 법정대리인의 권리</strong>
          <strong>․</strong>
          <strong>의무 및 행사방법</strong>
        </li>
      </ol>
      <p>
        ①&nbsp; 정보주체는 회사 서비스에 대해 언제든지 개인정보
        열람・정정・삭제・처리정지 및 철회 요구, 자동화된 결정에 대한 거부 또는
        설명 요구 등의 권리를 행사(이하 &ldquo;권리 행사&rdquo;라 함)할 수
        있습니다.
      </p>
      <p>
        &nbsp;※&nbsp; 14세 미만 아동에 관한 개인정보의 열람등 요구는
        법정대리인이 직접 해야 하며, 14세 이상의 미성년자인 정보주체는
        정보주체의 개인정보에 관하여 미성년자 본인이 권리를 행사하거나
        법정대리인을 통하여 권리를 행사할 수도 있습니다.
      </p>
      <p>
        ②&nbsp; 권리 행사는 회사 서비스에 대해 「개인정보 보호법」 시행령 제41조
        제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며,
      </p>
      <p>회사는 이에 대해 지체없이 조치하겠습니다.</p>
      <p>
        -&nbsp; 정보주체는 언제든지 홈페이지나 모바일 어플리케이션
        &lsquo;회원정보&rsquo;에서 개인정보를 직접 조회・수정・삭제하거나
        &lsquo;문의하기&rsquo;를 통해 열람을 요청할 수 있습니다.
      </p>
      <p>
        ③&nbsp; 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을
        통하여 하실 수도 있습니다. 이 경우 &ldquo;개인정보 처리 방법에 관한
        고시&rdquo; 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
      </p>
      <p>
        ④&nbsp; 정보주체가 개인정보 열람 및 처리 정지를 요구할 권리는 「개인정보
        보호법」 제35조 제4항 및 제37조 제2항에 의하여 제한될 수 있습니다.
      </p>
      <p>
        ⑤&nbsp; 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는
        해당 개인정보의 삭제를 요구할 수 없습니다.
      </p>
      <p>
        ⑥&nbsp; 자동화된 결정이 이루어진다는 사실에 대해 정보주체의 동의를
        받았거나, 계약 등을 통해 미리 알린 경우, 법률에 명확히 규정이 있는
        경우에는 자동화된 결정에 대한 거부는 인정되지 않으며 설명 및 검토 요구만
        가능합니다.
      </p>
      <p>
        -&nbsp; 또한 자동화된 결정에 대한 거부・설명 요구는 다른 사람의
        생명・신체・재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 등 정당한
        사유가 있는 경우에는 그 요구가 거절될 수 있습니다.
      </p>
      <p>
        ⑦ 회사는 권리 행사를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.
      </p>
      <p>⑧&nbsp; 회사는 권리 행사를 아래의 부서에 할 수 있습니다.</p>
      <p>회사는 정보주체의 권리 행사가 신속하게 처리되도록 노력하겠습니다.</p>
      <p>&nbsp; ▶ 개인정보 열람 등 청구 접수・처리 부서</p>
      <p>&nbsp;&nbsp;&nbsp; 부서명 : 정보보안팀</p>
      <p>&nbsp;&nbsp;&nbsp; 연락처 : air@inavi.kr, 1577-4242</p>
      <p>&nbsp;</p>
      <ol start="5">
        <li>
          <strong>개인정보의 처리위탁</strong>
        </li>
      </ol>
      <p>
        ① 회사는 서비스 향상을 위해서 고객님의 개인정보를 위탁업체에 수집, 처리,
        관리 등을 위탁할 수 있으며, 관계법령에 따라 위탁계약 시 개인정보가
        안전하게 관리될 수 있도록 규정하고 있습니다.
      </p>
      <p>
        1) 수탁자, 수탁범위 등에 관한 사항을 서면, 전자우편, 전화 또는
        홈페이지를 통해 게시
      </p>
      <p>
        2) 위탁계약 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외
        개인정보 처리금지, 개인정보의 기술적&bull;관리적 보호조치,
        서비스제공자의 개인정보보호 관련 지시엄수, 개인정보에 관한 비밀유지,
        제3자 제공의 금지 및 사고시의 책임부담, 위탁기간, 처리 종료후의
        개인정보의 반환 또는 파기 등을 규정하고 당해 계약내용을 서면 또는
        전자적으로 보관
      </p>
      <p>
        ② 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보
        처리방침을 통하여 공개하도록 하겠습니다.
      </p>
      <table width="604">
        <tbody>
          <tr>
            <td width="151">
              <p>수탁업체명</p>
            </td>
            <td width="454">
              <p>위탁업무 내용</p>
            </td>
          </tr>
          <tr>
            <td width="151">
              <p>Amazon Web Services</p>
            </td>
            <td width="454">
              <p>클라우드 인프라의 관리/운영</p>
            </td>
          </tr>
          <tr>
            <td width="151">
              <p>NHN Cloud</p>
            </td>
            <td width="454">
              <p>클라우드 인프라의 관리/운영</p>
            </td>
          </tr>
          <tr>
            <td width="151">
              <p>서초IDC</p>
            </td>
            <td width="454">
              <p>인프라의 관리/운영</p>
            </td>
          </tr>
          <tr>
            <td width="151">
              <p>주식회사 즐거운</p>
            </td>
            <td width="454">
              <p>모바일 쿠폰 문자메세지 발송, 민원 및 상담</p>
            </td>
          </tr>
          <tr>
            <td width="151">
              <p>팅크웨어(주)</p>
            </td>
            <td width="454">
              <p>통합 멤버쉽 회원관리, 개인정보 제공 동의 수령/관리</p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
      <p>
        회사는 원활한 서비스 제공을 위하여 아래와 같이 해외에 위치한 업체에
        개인정보 처리를 위탁하고 있습니다.
      </p>
      <p>&nbsp;</p>
      <p>
        개인정보의 국외이전을 거부하시려면 담당부서의 이메일(air@inavi.kr)로
        연락주시기 바랍니다. 다만 국외이전을 거부하실 경우 서비스 이용이 제한될
        수 있습니다.
      </p>
      <p>&nbsp;</p>
      <table width="604">
        <tbody>
          <tr>
            <td width="133">
              <p>
                개인정보를 이전 받는 자의 명칭 및 개인정보보호책임자의 연락처
              </p>
            </td>
            <td width="133">
              <p>이전되는 개인정보 항목</p>
            </td>
            <td width="81">
              <p>개인정보가 이전되는 국가</p>
            </td>
            <td width="79">
              <p>개인정보의 이전 일시 및 이전방법</p>
            </td>
            <td width="98">
              <p>이전받는 자의 개인정보 이용 목적</p>
            </td>
            <td width="81">
              <p>이전받는 자의 개인정보 보유 및 이용기간</p>
            </td>
          </tr>
          <tr>
            <td width="133">
              <p>Amazon Web Services (aws-korea-privacy@amazon.com)</p>
            </td>
            <td width="133">
              <p>개인위치정보</p>
            </td>
            <td width="81">
              <p>싱가폴</p>
            </td>
            <td width="79">
              <p>서비스 이용 시점에 네트워크를 통한 전송</p>
            </td>
            <td width="98">
              <p>해외 이용객 서비스 제공</p>
            </td>
            <td width="81">
              <p>위탁계약 종료 시 파기</p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
      <ol start="6">
        <li>
          <strong>개인정보의 제3자 제공</strong>
        </li>
      </ol>
      <p>
        ① 회사는 고객님의 개인정보를 「1. 개인정보의 수집범위 및 이용목적」에서
        고지한 범위 내에서 사용하며, 고객님의 사전 동의 없이 동 범위를 초과하여
        이용하거나 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다.
        다만, 아래의 경우 등 「개인정보 보호법」 제17조 및 제18조에 해당하는
        경우에는 개인정보를 제3자에게 제공합니다.
      </p>
      <p>1) 정보주체인 고객님이 제3자 제공에 동의한 경우</p>
      <p>
        2) 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한
        경우
      </p>
      <p>
        3) 공공기관이 법령 등에서 정하는 소관업무의 수행을 위하여 불가피한 경우
      </p>
      <p>
        4) 정보주체 또는 그 법정대리인이 의사표시를 할 수 없는 상태에 있거나
        주소불명 등으로 사전 동의를 받을 수 없는 경우로서 명백히 정보주체 또는
        제3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고 인정되는 경우
      </p>
      <p>② 회사의 개인정보 제3자 제공 현황은 다음과 같습니다.</p>
      <table>
        <tbody>
          <tr>
            <td width="150">
              <p>제공받는 자</p>
            </td>
            <td width="150">
              <p>제공받는 자의 개인정보 이용목적</p>
            </td>
            <td width="162">
              <p>제공하는 개인정보의 항목</p>
            </td>
            <td width="138">
              <p>제공받는 자의 보유 및 이용기간</p>
            </td>
          </tr>
          <tr>
            <td width="150">
              <p>그룹주행 참여자</p>
            </td>
            <td width="150">
              <p>그룹주행 시 그룹참여자간 위치공유</p>
            </td>
            <td width="162">
              <p>위치정보</p>
            </td>
            <td width="138">
              <p>서비스 제공 완료 후 유효기간 종료 즉시 파기</p>
            </td>
          </tr>
          <tr>
            <td width="150">
              <p>하이핀 친구</p>
            </td>
            <td width="150">
              <p>하이핀 친구위치공유</p>
            </td>
            <td width="162">
              <p>위치정보</p>
            </td>
            <td width="138">
              <p>서비스 제공 완료 후 유효기간 종료 즉시 파기</p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
      <ol start="7">
        <li>
          <strong>개인정보의 안전성 확보조치</strong>
        </li>
      </ol>
      <p>
        ① 기술적 조치 : 회사는 고객님의 개인정보를 처리함에 있어 개인정보가
        분실, 도난, 유출, 위조&bull;변조 또는 훼손 되지 않도록 안전성 확보를
        위하여 다음과 같은 기술적 조치를 취하고 있습니다.
      </p>
      <p>
        1) 고객님의 개인정보는 비밀번호에 의해 보호되며 파일 및 전송데이터를
        암호화하거나 파일잠금기능을 사용하여 중요한 데이터는 별도의 보안기능을
        통해 보호되고 있습니다.
      </p>
      <p>
        2) 회사는 암호알고리즘을 이용하여 네트워크 상의 개인정보를 안전하게
        전송할 수 있는 보안장치를 채택하고 있습니다.
      </p>
      <p>
        3) 해킹 등 외부침입에 대비하여 각 서버마다 침입차단시스템 및 취약점
        분석시스템 등을 이용하여 보안에 만전을 기하고 있습니다.
      </p>
      <p>② 관리적 조치</p>
      <p>
        1) 회사는 고객님의 개인정보에 대한 접근권한을 최소한의 인원으로 제한하고
        있으며, 개인정보를 처리하는 직원을 대상으로 새로운 보안기술 습득 및
        개인정보보호의무 등에 관해 정기적인 사내 교육 및 외부 위탁교육을
        실시하고 있습니다.
      </p>
      <p>
        2) 개인정보를 처리하는 최소한의 인원에 해당하는 자는 다음과 같습니다.
      </p>
      <p>- 이용자를 직접 상대로 하여 마케팅 업무를 수행하는 자</p>
      <p>- 개인정보보호책임자 및 담당자 등 개인정보처리업무를 수행하는 자</p>
      <p>- 기타 업무상 개인정보의 처리가 불가피한 자</p>
      <p>
        3) 입사 시 전 직원의 보안서약서를 통하여 사람에 의한 정보유출을 사전에
        방지하고 개인정보처리방침에 대한 이행사항 및 직원의 준수여부를 감시하기
        위한 내부절차를 마련하고 있습니다.
      </p>
      <p>
        4) 개인정보 관련 처리자의 업무 인수인계는 보안이 유지된 상태에서
        철저하게 이루어지고 있으며 입사 및 퇴사 후 개인정보 사고에 대한 책임을
        명확화하고 있습니다.
      </p>
      <p>
        5) 회사는 이용자 개인의 실수나 기본적인 인터넷의 위험성 때문에 일어나는
        일들에 대해 책임을 지지 않습니다. 고객님 개개인이 본인의 개인정보를
        보호하기 위해서 자신의 ID와 비밀번호를 적절하게 관리하고 여기에 대한
        책임을 져야 합니다.
      </p>
      <p>
        6) 그 외 내부 관리자의 실수나 기술관리 상의 사고로 인해 개인정보의 상실,
        유출, 위조&bull;변조, 훼손이 유발될 경우 회사는 즉각 고객님께 사실을
        알리고 적절한 대책과 보상을 강구할 것입니다.
      </p>
      <p>③ 물리적 조치</p>
      <p>
        1) 전산실 및 자료 보관실 등을 특별 보호구역으로 설정하여 출입을 통제하고
        있습니다.
      </p>
      <p>
        2) 개인정보와 일반 데이터를 혼합하여 보관하지 않고 별도의 서버를 통해
        분리하여 보관하고 있습니다.
      </p>
      <p>&nbsp;</p>
      <ol start="8">
        <li>
          <strong>
            개인정보 자동 수집 장치의 설치∙운영 및 거부에 관한 사항
          </strong>
        </li>
      </ol>
      <p>
        ① 회사는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를
        저장하고 수시로 불러오는 &lsquo;쿠키(cookie)&rsquo;를 사용합니다.
      </p>
      <p>
        ② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터
        브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의
        하드디스크에 저장되기도 합니다.
      </p>
      <p>
        1) 쿠키의 사용목적 : 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문
        및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게
        최적화된 정보 제공을 위해 사용됩니다.
      </p>
      <p>2) 쿠키의 설치∙운영 및 거부</p>
      <p>가. 웹 브라우저</p>
      <p>
        [Chrome: 웹 브라우저 설정 &gt; 개인정보 보호 및 보안 &gt; 인터넷 사용
        기록 삭제]
      </p>
      <p>
        [Edge: 웹 브라우저 설정 &gt; 쿠키 및 사이트 권한 &gt; 쿠키 및 사이트
        데이터 관리 및 삭제]
      </p>
      <p>
        [Safari: 환경설정 &gt; &lsquo;크로스 사이트 추적 방지&rsquo; 및
        &lsquo;모든 쿠키 차단&rsquo;]
      </p>
      <p>
        * 이 외에도 Firefox, Opera 등 주요 인터넷 웹브라우저들도 쿠키 삭제
        기능을 제공하고 있습니다.
      </p>
      <p>* 웹 브라우저 버전에 따라 쿠키 수집 거부 방법이 상이할 수 있습니다.</p>
      <p>나. 모바일</p>
      <p>
        [Android: 설정 &gt; 보안 및 개인정보 보호 &gt; 개인정보 보호 &gt; 기타
        개인정보 설정 &gt; 광고 &gt; 광고ID 재설정 또는 광고ID 삭제]
      </p>
      <p>
        [iOS: 설정 &gt; 개인정보 보호 및 보안 &gt; 추적 &gt; 앱 추적 허용 해제]
      </p>
      <p>* 모바일 OS 버전에 따라 메뉴 및 방법이 상이 할 수 있습니다.</p>
      <p>
        3) 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수
        있습니다.
      </p>
      <p>
        ③ 회사는 생성전보 수집 틀을 통하여 IP주소, MAC주소, 서비스 이용기록,
        방문기록, 웹로그, 불량이용기록, 모바일기기 정보를 수집할 수 있습니다.
      </p>
      <p>&nbsp;</p>
      <ol start="9">
        <li>
          <strong>개인 아이디와 비밀번호 관리</strong>
        </li>
      </ol>
      <p>
        ① 고객님이 사용하고 계시는 ID와 비밀번호는 원칙적으로 고객님만
        사용하도록 되어 있습니다. 회사는 고의 또는 과실이 없는 경우에, 고객님의
        ID와 비밀번호 도용 또는 기타 타인의 사용으로 의해 발생된 문제에 대하여
        회사가 책임지지 않습니다. 어떠한 경우에도 비밀번호는 타인에게 알려 주지
        마시고 로그인 상태에서는 주위의 다른 사람에게 개인 정보가 유출되지
        않도록 특별한 주의를 기울여 주시기 바랍니다.
      </p>
      <p>
        ② 타인의 주민등록번호 등 개인정보를 도용하여 고객님의 가입 또는 구매가
        확인되었을 경우에는 이용계약이 일방적으로 해지될 수 있으며, 주민등록법에
        의해 3년 이하의 징역 또는 3천만원 이하의 벌금이 부과될 수 있습니다.
      </p>
      <p>&nbsp;</p>
      <ol start="10">
        <li>
          <strong>링크사이트</strong>
        </li>
      </ol>
      <p>
        회사는 고객님께 다른 회사의 웹사이트 또는 자료에 대한 링크를 제공할 수
        있습니다. 이 경우 회사는 외부사이트 및 자료에 대한 아무런 통제권이
        없으므로 그로부터 제공받는 서비스나 자료의 유용성에 대해 책임질 수
        없으며 보증할 수 없습니다. 회사가 포함하고 있는 링크를 클릭(click)하여
        타 사이트(site)의 페이지로 옮겨갈 경우 해당 사이트의 개인정보처리방침에
        대해 회사는 무관하므로 새로 방문한 사이트의 정책을 검토해 보시기
        바랍니다.
      </p>
      <p>&nbsp;</p>
      <ol start="11">
        <li>
          <strong>개인정보보호책임자 및 담당부서</strong>
        </li>
      </ol>
      <p>
        ① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와
        관련한 정보주체의 불만처리 및 피해구제 등을 위하여 개인정보보호책임자 및
        담당자를 아래와 같이 지정합니다.
      </p>
      <table>
        <tbody>
          <tr>
            <td width="200">
              <p>구분</p>
            </td>
            <td width="200">
              <p>개인정보보호책임자</p>
            </td>
            <td width="200">
              <p>개인정보보호관리자</p>
            </td>
          </tr>
          <tr>
            <td width="200">
              <p>성명</p>
            </td>
            <td width="200">
              <p>박준석</p>
            </td>
            <td width="200">
              <p>박용관</p>
            </td>
          </tr>
          <tr>
            <td width="200">
              <p>소속부서</p>
            </td>
            <td width="200">
              <p>정보보안팀</p>
            </td>
            <td width="200">
              <p>정보보안팀</p>
            </td>
          </tr>
          <tr>
            <td width="200">
              <p>직위</p>
            </td>
            <td width="200">
              <p>CPO</p>
            </td>
            <td width="200">
              <p>이사</p>
            </td>
          </tr>
          <tr>
            <td width="200">
              <p>전자우편</p>
            </td>
            <td width="200">
              <p>air@inavi.kr</p>
            </td>
            <td width="200">
              <p>air@inavi.kr</p>
            </td>
          </tr>
          <tr>
            <td width="200">
              <p>전화번호</p>
            </td>
            <td width="200">
              <p>1577-4242</p>
            </td>
            <td width="200">
              <p>1577-4242</p>
            </td>
          </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
      <p>
        ② 정보주체인 고객님은 회사의 서비스를 이용하시면서 발생한 모든 개인정보
        보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보보호책임자
        및 담당부서로 문의하실 수 있습니다. 회사는 정보주체인 고객님의 문의에
        대해 지체없이 답변 및 처리해 드릴 것입니다.
      </p>
      <p>
        ③ 고객님은 「개인정보 보호법」 제35조에 따른 개인정보의 열람청구를
        개인정보보호책임자 및 담당부서에 할 수 있으며, 회사는 고객님의 개인정보
        열람청구가 신속하게 처리되도록 노력할 것입니다.
      </p>
      <p>
        ④ 아래 기관은 회사와는 별개의 기관으로서, 개인정보가 침해되어 이에 대한
        신고나 상담이 필요하신 경우에 아래 기관에 문의하시면 도움을 받으실 수
        있습니다.
      </p>
      <p>&nbsp;</p>
      <p>▶ 개인정보 침해신고센터 (한국인터넷진흥원 운영)</p>
      <p>- 소관업무 : 개인정보 침해사실 신고, 상담 신청</p>
      <p>- 홈페이지 : privacy.kisa.or.kr</p>
      <p>- 전화 : (국번없이) 118</p>
      <p>- 주소 : (58324) 전남 나주시 진흥길 9(빛가람동 301-2) 3층</p>
      <p>▶ 개인정보 분쟁조정위원회</p>
      <p>- 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)</p>
      <p>- 홈페이지 : www.kopico.go.kr</p>
      <p>- 전화 : (국번없이) 1833-6972</p>
      <p>- 주소 : (03171)서울특별시 종로구 세종대로 209 정부서울청사 12층</p>
      <p>▶ 대검찰청 : 02-3480-3570 (www.spo.go.kr)</p>
      <p>▶ 경찰청 사이버수사국 : 182 (ecrm.cyber.go.kr)</p>
      <p>&nbsp;</p>
      <ol start="12">
        <li>
          <strong>개인위치정보의 처리</strong>
        </li>
      </ol>
      <p>
        ① 회사는 위치정보의 보호 및 이용 등에 관한 법률(이하
        &ldquo;위치정보법&rdquo;이라 함)에 따라 위치 서비스 이용약관에서 정한
        목적 범위 내에서 개인위치정보를 수집&middot;이용&middot;제공하며,
        이용자의 개인위치정보를 안전하게 관리합니다.
      </p>
      <p>
        ② 회사는 위치정보의 보호 및 이용에 관한 법률 제16조 제2항에 근거하여
        회원에 대한 개인위치정보 수집, 이용, 제공사실 확인자료를
        위치정보시스템에 자동으로 기록하며, 기록시점으로부터 6개월간 보존합니다.
      </p>
      <p>
        ③ 회사는 회원탈퇴 등 처리목적이 달성된 경우, 개인위치정보를 복구 및
        재생이 불가능한 방법으로 지체없이 파기합니다.
      </p>
      <p>
        ④ 회사는 개인위치정보주체의 사전 동의 없이 위치정보를 외부에 제공하지
        않습니다. 단, 개인위치정보주체가 직접 동의를 한 경우, 그리고 관련 법령에
        의거하여 제출 의무가 발생한 경우, 이용자의 생명이나 안전에 급박한 위험이
        확인되어 이를 해소하기 위한 경우에 한하여 개인위치정보를 제공합니다.
      </p>
      <p>
        ⑤ 회사는 회원의 개인위치정보를 회원이 지정하는 제3자에게 제공할 경우
        매회 회원에게 제공받는 자, 제공일시 및 제공목적을 이동전화
        문자메시지(SMS)등의 방법을 통해 회원의 이동전화 단말기로 즉시
        통보합니다. 다만, 회사는 회원이 미리 요청한 경우에 한하여 회원이 지정한
        이동전화 단말기 또는 전자우편주소로 통보할 수 있습니다.
      </p>
      <p>
        ⑥ 회사는 아래의 경우에 해당하는 자(이하 &ldquo;8세 이하의
        아동&rdquo;등이라 한다)의 보호의무자가 8세이하의 아동 등의 생명 또는
        신체보호를 위하여 개인위치정보의 수집, 이용 또는 제공에 동의하는
        경우에는 본인의 동의가 있는 것으로 봅니다.
      </p>
      <p>1) 8세 이하의 아동</p>
      <p>2) 피성년후견인</p>
      <p>
        3) 장애인복지법 제2조제2항제2호의 규정에 의한 정신적 장애를 가진 자로서
        장애인고용촉진및직업재활법 제2조제2호의 규정에 의한 중증장애인에
        해당하는 자(장애인복지법 제32조의 규정에 의하여 장애인등록을 한 자에
        한한다)
      </p>
      <p>
        ⑦ 8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 개인위치정보의
        수집․이용 또는 제공에 동의를 하고자 하는 보호의무자는 서면동의서에
        보호의무자임을 증명하는 서면을 첨부하여 회사에 제출하여야 합니다.
      </p>
      <p>
        ⑧ 회사는 개인위치정보를 적절히 관리‧보호하고, 이용자의 불만, 요청등을
        원활하게 처리할 수 있도록 위치정보관리책임자를 지정하여 운영하고
        있습니다. 위치치정보관리책임자는 성명과 연락처는 아래와 같습니다.
      </p>
      <p>1) 위치정보관리책임자: 박준석 CPO</p>
      <p>2) 전화번호: 1577-4242</p>
      <p>3) 이메일: air@inavi.kr</p>
      <p>&nbsp;</p>
      <p>&lt;부칙&gt;</p>
      <p>1) 본 개인정보처리방침은 2025. 02. 27부터 적용됩니다.</p>
      <p>
        2) 위 내용에 대한 추가, 삭제 및 수정이 있을 경우에는 시행하는 날로부터
        최소 7일전에 공지사항 등을 통해 이용자에게 공지하겠습니다.
      </p>
    </div>
  );
};

export default PartnershipTerms;
